import {
    GET_DELIVERY_PRICE_REPORT
} from './deliveryPriceReport.actionsTypes';

export default function deliveryPriceReport(state = [], action) {
    let newState = Object.assign([], state);
    switch (action.type) {
        case GET_DELIVERY_PRICE_REPORT:
            return [
                 ...action.report
            ]
        default:
            return newState;
    }
}

